import { render, staticRenderFns } from "./IframeBackofficeConnection.vue?vue&type=template&id=05ba06de&"
import script from "./IframeBackofficeConnection.vue?vue&type=script&lang=js&"
export * from "./IframeBackofficeConnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports